import './loading-skeleton.css';
/** Content-shaped placeholders; no fake balances or interactive controls while loading. */
export function LoadingSkeleton({
  label = 'Loading',
  compact = false,
}: {
  label?: string;
  compact?: boolean;
}) {
  return (
    <div
      className={`loading-skeleton ${compact ? 'loading-skeleton-compact' : ''}`}
      role="status"
      aria-label={label}
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">{label}</span>
      <div aria-hidden="true">
        <div className="skeleton-line skeleton-title" />
        <div className="skeleton-line skeleton-subtitle" />
        {!compact && (
          <div className="skeleton-metrics">
            {[0, 1, 2].map((n) => (
              <div className="skeleton-card" key={n}>
                <div className="skeleton-line" />
                <div className="skeleton-line skeleton-amount" />
              </div>
            ))}
          </div>
        )}
        <div className="skeleton-list">
          {[0, 1, 2].map((n) => (
            <div className="skeleton-row" key={n}>
              <div className="skeleton-avatar" />
              <div>
                <div className="skeleton-line" />
                <div className="skeleton-line skeleton-subtitle" />
              </div>
              <div className="skeleton-line skeleton-end" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
